import { Action } from '@ngrx/store';
import { ConfigState } from '@digitaix/types';

export enum ConfigActionTypes {
  SetConfig = '@digitaix/core/config/SET_CONFIG',
  SetEnvironment = '@digitaix/core/config/SET_ENVIRONMENT',
}

export class SetEnvironment<E = any> implements Action {
  public readonly type = ConfigActionTypes.SetEnvironment;

  constructor(public environment: E) {}
}

export class SetConfig implements Action {
  readonly type = ConfigActionTypes.SetConfig;

  constructor(public config: ConfigState) {}
}

export type ConfigActions = SetConfig | SetEnvironment;
